import { Component, ViewChild, ElementRef, VERSION } from '@angular/core';

@Component({
  selector: 'app-password',
  template: `
    <button type="button" (click)="generatePassword()">{{buttonLabel}}</button>
    `
})
export class PasswordComponent {
  // Alternative for checkboxes
  checkboxes = [
    {
      "id": "lowercase",
      "label": "a-z",
      "library": "abcdefghijklmnopqrstuvwxyz"
    }, {
      "id": "uppercase",
      "label": "A-Z",
      "library": "ABCDEFGHIJKLMNOPWRSTUVWXYZ"
    }, {
      "id": "numbers",
      "label": "0-9",
      "library": "0123456789"
    }, {
      "id": "symbols",
      "label": "!-?",
      "library": "!@#$%^&*-_=+\\|:;',.\<>/?~"
    }
  ]

  dictionary: Array<String>;

  passwordLenght: Number = 8;
  buttonLabel: String = "Generar contraseña";
  newPassword: String;
  show: boolean = false;

  // Generate password
  generatePassword() {

    // Create array from chosen checkboxes
    this.dictionary = [].concat(
      this.checkboxes[0].library.split(""),
      this.checkboxes[1].library.split(""),
      this.checkboxes[2].library.split(""),
      this.checkboxes[3].library.split("")
    );

    // Generate random password from array
    var newPassword = "";
    for (var i = 0; i < this.passwordLenght; i++) {
      newPassword += this.dictionary[Math.floor(Math.random() * this.dictionary.length)];
    }
    this.newPassword = newPassword;
    return this.newPassword;
  }

  showPassword() {
    this.show = this.show ? false : true;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/password/password.component.ts